import { encode as base64_encode } from "base-64";
import { postApi, baseURL } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";
import { message } from "antd";
import config from "../config";

class PassengerLogReportStore {
  passengerLogReport = [];
  total = 0;
  loading = false;
  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      passengerLogReport: observable,
      total: observable,
      loading: observable,
      loadData: action,
      exportExcel: action,
      exportpdf:action,
      exportcsv:action,
      exportxml:action
    });
    this.rootStore = rootStore;
  }

  async loadData({ offset, limit, companyId, fromDate, toDate, vehicleId, pageNo }) {
    this.loading = true;
    var postData = {
      companyId: companyId,
      vehicleId: vehicleId,
      fromDate: fromDate,
      toDate: toDate,
      offset: offset,
      PickDrop: "All",
      limit: limit,
      page: pageNo,
    };

    if(config.pythonReport === 1){
        var response = await postApi.getClient('report').post("/miscellaneous_report/passengerlog", postData);
    }else{
        const base64Input = await base64_encode(JSON.stringify(postData));
        response = await postApi.getClient().post("index.php?c=vehicle&a=passengerlog", "postData=" + base64Input);
    }

    this.passengers = response?.data?.data?.passengerLog;

    this.total = parseInt(response?.data?.data?.TotalCount);
    this.loading = false;
  }

  async exportExcel(getData) {

    if(config.pythonReport === 1){    
      try {
          var response = await postApi.getClient("report").post("/miscellaneous_report/passengerlog/download/excel", getData, {
              responseType: "blob",
          });
      
          const blob = new Blob([response.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
      
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = "Passenger Log Report.xlsx";
      
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
    
      } catch (error) {
          message.error("Failed to download the report. Please try again.")
      }

    }else{
        let lang = "english";
        window.location.href =
          baseURL +
          "index.php?c=vehicle&a=exportpasslogexcel&cid=" +
          getData.companyId +
          "&vid=" +
          getData.vehicleId +
          "&fD=" +
          getData.fromDate +
          "&tD=" +
          getData.toDate +
          "&colList=" +
          getData.colList +
          "&language=" +
          lang;
    }
  }

  async exportpdf(getData) {

    if(config.pythonReport === 1){    
      try {

        var response = await postApi.getClient("report").post("/miscellaneous_report/passengerlog/download/pdf", getData, {
            responseType: "blob",
        });
    
        const blob = new Blob([response.data], {
            type: 'application/pdf'
        });
    
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "Passenger Log Report.pdf";
    
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      
      } catch (error) {
          message.error("Failed to download the report. Please try again.")
      }

    }else{
        let lang = "english";
        window.location.href =
          baseURL +
          "index.php?c=vehicle&a=exportpasslogpdf&cid=" +
          getData.companyId +
          "&vid=" +
          getData.vehicleId +
          "&fD=" +
          getData.fromDate +
          "&tD=" +
          getData.toDate +
          "&colList=" +
          getData.colList;
    }
    
  }

  async exportcsv(getData) {
    let lang = "english";
    window.location.href =
      baseURL +
      "index.php?c=vehicle&a=exportpasslogcsv&cid=" +
      getData.companyId +
      "&vid=" +
      getData.vehicleId +
      "&fD=" +
      getData.fromDate +
      "&tD=" +
      getData.toDate +
      "&colList=" +
      getData.colList +
      "&language=" +
      lang;
  }

  async exportxml(getData) {
    let lang = "english";
    window.location.href =
      baseURL +
      "index.php?c=vehicle&a=exportpasslogxml&cid=" +
      getData.companyId +
      "&vid=" +
      getData.vehicleId +
      "&fD=" +
      getData.fromDate +
      "&tD=" +
      getData.toDate +
      "&colList=" +
      getData.colList +
      "&language=" +
      lang;
  }



}

export default PassengerLogReportStore;
